import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { axiosInstance } from '../App';
import CreateApprovalStepper from './CreateApprovalStepper';
import { toast } from 'sonner';
import { decryptId } from '../utils/urlEncryption';

const EditApproval = ({ user, onLogout }) => {
  const { approvalId: encryptedApprovalId } = useParams();
  
  // Decrypt the approval ID from URL
  const approvalId = decryptId(encryptedApprovalId);
  
  const [approval, setApproval] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadApproval();
  }, [approvalId]);

  const loadApproval = async () => {
    try {
      const res = await axiosInstance.get(`/approvals/${approvalId}`);
      setApproval(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error loading approval');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading approval data...</p>
        </div>
      </div>
    );
  }

  if (!approval) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
        <p className="text-gray-600">Approval not found</p>
      </div>
    );
  }

  return (
    <CreateApprovalStepper 
      user={user} 
      onLogout={onLogout} 
      editMode={true}
      existingApproval={approval}
    />
  );
};

export default EditApproval;
